import React, { useMemo, useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import './Testimonials.css'

const testimonials = [
  { name: 'Sarah M.', avatar: 'https://i.pravatar.cc/256?img=10' , text: 'We reserved our Cane Corso and the process was smooth from start to finish. Weekly photo updates and clear communication. Highly recommend!', rating: 5 },
  { name: 'Daniel K.', avatar: 'https://i.pravatar.cc/256?img=12', text: 'Picked up our puppy last weekend. Healthy, confident, and exactly as described. The team answered every question promptly.', rating: 5 },
  { name: 'Olivia R.', avatar: 'https://i.pravatar.cc/256?img=32', text: 'Excellent service! They helped us choose the right temperament for our family. Our girl settled in immediately.', rating: 5 },
  { name: 'Jacob T.', avatar: 'https://i.pravatar.cc/256?img=15', text: 'Very professional breeder. Vet records were complete, and pickup day was organized. Our boy is thriving.', rating: 5 },
  { name: 'Aisha B.', avatar: 'https://i.pravatar.cc/256?img=47', text: 'We reserved months in advance and got regular updates. The puppy came well socialized and crate‑trained basics. Wonderful experience.', rating: 5 },
  { name: 'Marco L.', avatar: 'https://i.pravatar.cc/256?img=5', text: 'Transparent pricing and no surprises. We received a starter kit and feeding guide that made the first week easy.', rating: 5 },
  { name: 'Priya S.', avatar: 'https://i.pravatar.cc/256?img=49', text: 'Our Cane Corso puppy is stunning and so gentle with our kids. Support after pickup was outstanding.', rating: 5 },
  { name: 'Ethan D.', avatar: 'https://i.pravatar.cc/256?img=20', text: 'Paperwork, microchip, and shots were all in order. You can tell they truly care about the breed.', rating: 5 },
  { name: 'Grace P.', avatar: 'https://i.pravatar.cc/256?img=38', text: 'We were nervous first‑time owners, but they guided us patiently. Our puppy sleeps through the night already!', rating: 5 },
  { name: 'Liam H.', avatar: 'https://i.pravatar.cc/256?img=28', text: 'From reservation to pickup day, everything was on time and professional. Couldn’t be happier.', rating: 5 },
  { name: 'Zoe C.', avatar: 'https://i.pravatar.cc/256?img=45', text: 'Great communication and honest advice about training and food. Our vet was impressed with the records.', rating: 5 },
  { name: 'Ahmed N.', avatar: 'https://i.pravatar.cc/256?img=3', text: 'We visited the kennel before reserving—clean, friendly, and well run. Puppy has a fantastic temperament.', rating: 5 },
  { name: 'Nina V.', avatar: 'https://i.pravatar.cc/256?img=31', text: 'They matched us with a calmer pup perfect for apartment living. Follow‑up messages after pickup meant a lot.', rating: 5 },
  { name: 'Carlos M.', avatar: 'https://i.pravatar.cc/256?img=6', text: 'Our family loves him already. Healthy weight, shiny coat, and a confident little guardian. Thank you!', rating: 5 },
]

const container = { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { duration: 0.6 } } }
const item = { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { duration: 0.45 } } }

// Duplicate testimonials to create a seamless infinite loop
const useLoopedTestimonials = (list, times = 2) =>
  useMemo(() => Array(times).fill(null).flatMap(() => list), [list, times])

const Testimonials = () => {
  const ref = useRef(null)
  const inView = useInView(ref, { once: true, margin: '-80px' })
  const items = useLoopedTestimonials(testimonials, 2)

  return (
    <section id="testimonials" className="testimonials" ref={ref}>
      <div className="container">
        <motion.div className="testimonials-header" variants={container} initial="hidden" animate={inView ? 'visible' : 'hidden'}>
          <h2>What Clients Say</h2>
          <p>Real feedback from teams we’ve helped deliver results for.</p>
        </motion.div>

        <motion.div className="carousel" variants={container} initial="hidden" animate={inView ? 'visible' : 'hidden'}>
          <div className="carousel-track" aria-live="polite">
            {items.map((t, i) => (
              <motion.article key={i} className="testimonial-card" variants={item}>
                <div className="quote">“{t.text}”</div>
                <div className="author">
                  <img
                    className="avatar-img"
                    src={t.avatar}
                    alt={`${t.name} avatar`}
                    loading="lazy"
                    onError={(e) => {
                      e.currentTarget.onerror = null
                      const idx = (i % 70) + 1
                      e.currentTarget.src = `https://i.pravatar.cc/256?img=${idx}`
                    }}
                  />
                  <div className="meta">
                    <div className="name">{t.name}</div>
                  </div>
                  <div className="stars" aria-label={`${t.rating} out of 5 stars`}>{'★★★★★'.slice(0, t.rating)}</div>
                </div>
              </motion.article>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default Testimonials
